import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as firebaseui from 'firebaseui';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';
import firebase from 'firebase/app';
import EmailAuthProvider = firebase.auth.EmailAuthProvider;
import GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
import { Authentication } from '../services/authentication';
import * as annyang from 'annyang'




@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {


    constructor(private authenticationService:Authentication) {
        var annyang :annyang.Annyang
        if (annyang) {
        var commands = {
            'hello': function() { alert('Hello world!'); }
          };
         
          // Add our commands to annyang
          annyang.addCommands(commands);
         
          // Start listening.
          annyang.start();
        }
    }

    email: string;
password: string;

// signUp() {
// this.authenticationService.SignUp(this.email, this.password);
// this.email = '';
// this.password = '';
// }

signIn() {
   
this.authenticationService.SignIn(this.email, this.password);
this.email = '';
this.password = '';
}
    ngOnInit() {

    }

    ngOnDestroy() {

    }
}


